import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { IState } from 'legacy/lut/store'

import { IFinSobSidePanelSetting } from 'partner360/models/finSobSidePanel/IFinSobSidePanelSetting'

import { selectFinSobSidePanelState } from './selectFinSobSidePanelState'

const NO_DATA: IFinSobSidePanelSetting[] = []

/** The side panel's categories for the offering the plan shows, which is not always the one
 *  picked: Overall's plan shows `Consolidated`. */
export const selectFinSobSidePanelData = (state: IState, programType: ProgramTypes) =>
  selectFinSobSidePanelState(state).data[programType] ?? NO_DATA
